/**
 * Strips the content reference index prefix from a minute node item ID.
 * This is used to convert IDs like '0.DISCUSSION_POINT.1' to 'DISCUSSION_POINT.1'
 * for DOM element queries, since the HTML elements don't include the index prefix.
 */
export function stripContentRefIndexPrefix(id: string): string {
  return id.replace(/^\d+\./, '')
}

export function normalizeNodeId(nodeId: string): string {
  const strippedId = stripContentRefIndexPrefix(nodeId)

  if (!strippedId.includes(':')) {
    return strippedId
  }

  const tokens = strippedId.split(':')

  return tokens.length > 1 ? tokens[1] : strippedId
}
